'use strict';

var id            = 'pageScanOptions',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    RadioList     = require('mag-component-radio-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    Scrollbar     = require('stb-component-scrollbar'),
    Footer        = require('mag-component-footer'),
    // Flicker       = require('spa-component-flicker'),
    Button        = require('stb-component-button'),
    modalScroll   = new Scrollbar(),

    symbolRateRange = {
        start: 870,
        end: 7200,
        fefaultState: 6875
    },

    frequencyRange = {
        start: 50000,
        end: 858000,
        step: 500
    },

    scanConfig = {
        manual: false,
        more: false,
        currentType: {},
        symbolRate: 6850,
        modulation: 0,
        frequencyStart: 50000,
        frequencyEnd: 858000,
        frequency: 50000,
        bandwidth: 8,
        network: ''
    },

    scanType = {
        name: 'scanType',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Scanning type') + ':'
            },
            {
                name: '$text',
                className: 'text',
                value: gettext('Auto')
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalScan.show();
            page.modalScan.focus();
        }
    },

    typeItemText,
    typeItem = {
        name: 'type',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('DVB type') + ':'
            },
            typeItemText = {
                name: '$text',
                className: 'text',
                value: ''
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalTypes.show();
            page.modalTypes.focus();
        }
    },

    symbolRateText,
    symbolRate = {
        name: 'symbolRate',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Symbol rate') + ':'
            },
            symbolRateText = {
                name: '$text',
                className: 'text',
                value: '' + scanConfig.symbolRate
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalSymbolRate.show();
            page.modalSymbolRate.focus();
        }
    },

    modulationText,
    modulation = {
        name: 'modulation',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Modulation') + ':'
            },
            modulationText = {
                name: '$text',
                className: 'text',
                value: gettext('Auto')
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalModulation.show();
            page.modalModulation.focus();
        }
    },

    scanTypeManual = {
        items: [
            {
                className: 'name theme-subhead-color',
                value: gettext('Scanning type') + ':'
            },
            {
                className: 'text',
                value: gettext('Manual')
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalScan.show();
            page.modalScan.focus();
        }
    },

    frequencyStartText,
    frequencyStart = {
        name: 'frequencyStart',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Start frequency (KHz)') + ':'
            },
            frequencyStartText = {
                name: '$text',
                className: 'text',
                value: '' + scanConfig.frequencyStart
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalFrequencyStart.show();
            page.modalFrequencyStart.focus();
            page.footer.hide();
        },
        manualEdit: true,
        configValue: 'frequencyStart'
    },

    frequencyEndText,
    frequencyEnd = {
        name: 'frequencyEnd',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('End frequency (KHz)') + ':'
            },
            frequencyEndText = {
                name: '$text',
                className: 'text',
                value: '' + scanConfig.frequencyEnd
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalFrequencyEnd.show();
            page.modalFrequencyEnd.focus();
            page.footer.hide();
        },
        manualEdit: true,
        configValue: 'frequencyEnd'
    },

    bandwidthText,
    bandwidth = {
        name: 'bandwidth',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Bandwidth (MHz)') + ':'
            },
            bandwidthText = {
                name: '$text',
                className: 'text',
                value: scanConfig.bandwidth + ''
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalBand.show();
            page.modalBand.focus();
        }
    },

    frequencyItemText,
    frequencyItem = {
        name: 'frequency',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Frequency (KHz)') + ':'
            },
            frequencyItemText = {
                name: '$text',
                className: 'text',
                value: '' + scanConfig.frequency
            }
        ],
        className: 'theme-item-more',
        click: function () {
            page.panelSet.blur();
            page.modalFrequency.show();
            page.modalFrequency.focus();
            page.footer.hide();
        },
        manualEdit: true,
        configValue: 'frequency'
    },

    networkID = {
        name: 'networkID',
        items: [
            {
                name: '$name',
                className: 'name theme-subhead-color',
                value: gettext('Network ID') + ':'
            },
            {
                name: '$text',
                className: 'text',
                value: '' + scanConfig.network
            }
        ],
        className: 'theme-item-more',
        click: function () {
            window.core.intent({
                action: 'keyboard',
                data: {
                    value: scanConfig.network,
                    title: gettext('Network ID'),
                    mode: 'number'
                },
                events: {
                    done: function ( event ) {
                        if ( event.value ) {
                            try {
                                scanConfig.network = parseInt(event.value, 10);
                            } catch ( error ) {
                                event.stop = true;
                                window.core.notify({
                                    title: 'Network ID is not correct',
                                    icon: 'alert',
                                    type: 'warning',
                                    timeout: 5000
                                });
                            }
                        }
                    }
                }
            }, function ( error ) {
                console.log(error);
            });

        }
    },

    autoList = [scanType, typeItem, symbolRate, modulation],
    manualList = [scanTypeManual, typeItem, frequencyStart, frequencyEnd, bandwidth],
    manualMoreList = [scanTypeManual, typeItem, symbolRate, modulation, frequencyItem, networkID],

    $channelsCountWrapper, $channelsCount,
    listData, index, focusIndex,
    typesList, middleList;


function editManual () {
    var activeItem =  middleList.$focusItem;

    if ( DEVELOP ) {
        window.activeItem = activeItem;
    }
    core.intent({
        action: 'keyboard',
        data: {
            mode: 'number',
            icon: null,
            title: activeItem.links.$name.innerText,
            value: activeItem.links.$text.innerText
        },
        events: {
            done: function ( event ) {
                var frequency;

                try {
                    frequency = parseInt(event.value, 10);
                } catch ( error ) {
                    core.notify({
                        title: gettext('Value is incorrect'),
                        icon: 'alert',
                        type: 'error',
                        timeout: 3000
                    });
                }

                if ( frequency >= frequencyRange.start && frequency <= frequencyRange.end ) {
                    activeItem.links.$text.innerText = frequency + '';
                    scanConfig[activeItem.data.configValue] = frequency;
                } else {
                    core.notify({
                        title: gettext('Value is incorrect'),
                        icon: 'alert',
                        type: 'error',
                        timeout: 3000
                    });
                }
            }
        }
    });
}


$channelsCountWrapper = dom.tag('div', {className: 'amountContainer'}, $channelsCount = dom.tag('div', {className: 'amount'}, '0'));


page.modalScan = new ModalMessage({
    visible: false,
    title: gettext('Scanning types'),
    events: {
        show: function () {
            this.focus();
            page.footer.hide();
        }
    },
    children: [
        new RadioList({
            focusIndex: 0,
            size: 2,
            cycle: true,
            data: [
                {
                    state: true,
                    title: gettext('Auto'),
                    value: false
                },
                {
                    state: false,
                    title: gettext('Manual'),
                    value: true
                }
            ],
            events: {
                'click:item': function () {
                    page.modalScan.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalScan.hide();
                        page.middlePanel.focus();
                    }
                },
                select: function ( item ) {
                    scanConfig.manual = item.data.value;
                    page.middlePanel.reset();
                }
            }
        })
    ]
});
page.add(page.modalScan);


page.modalTypes = new ModalMessage({
    visible: false,
    title: gettext('DVB types'),
    events: {
        show: function () {
            var list = app.provider.types.current,
                selectedIndex = 0,
                data = [],
                typeIndex;

            for ( typeIndex = 0; typeIndex < list.length; typeIndex++ ) {
                data.push({
                    state: list[typeIndex].type === scanConfig.currentType.type,
                    title: list[typeIndex].name,
                    value: list[typeIndex]
                });
                if ( list[typeIndex].type === scanConfig.currentType.type ) {
                    selectedIndex = typeIndex;
                }
            }
            typesList.init({data: data, size: data.length, focusIndex: selectedIndex});
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    },
    children: [
        typesList = new RadioList({
            cycle: true,
            scroll: modalScroll,
            data: [],
            events: {
                'click:item': function () {
                    page.modalTypes.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalTypes.hide();
                        page.middlePanel.focus();
                    }
                },
                select: function ( item ) {
                    scanConfig.currentType = item.data.value;
                    middleList.links.type.links.$text.innerText = scanConfig.currentType.name;
                    typeItemText.value = scanConfig.currentType.name;
                }
            }
        }),
        modalScroll
    ]
});
page.add(page.modalTypes);


page.footer = new Footer({
    visible: true,
    parent: page,
    data: [
        {
            code: keys.f1,
            title: gettext('Manual correction'),
            action: editManual
        },
        {
            code: keys.menu,
            action: function () {
                page.modalActions.show();
            }
        }
    ]
});


page.modalActions = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () {
            page.panelSet.blur();
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
            if ( middleList.$focusItem.data.manualEdit ) {
                page.footer.show();
            }
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            size: 1,
            focusIndex: 0,
            data: [
                {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Manual correction')}
                    ],
                    click: function () {
                        editManual();
                        page.modalActions.hide();
                    }
                }
            ],
            events: {
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back || event.code === keys.menu ) {
                        event.stop = true;
                        page.modalActions.hide();
                    }
                }
            }
        })
    ]
});
page.add(page.modalActions);


listData = [];
for ( index = symbolRateRange.start; index <= symbolRateRange.end; index++ ) {
    listData.push(
        {
            state: index === symbolRateRange.fefaultState,
            value: index,
            title: index
        }
    );
}
focusIndex = symbolRateRange.fefaultState - symbolRateRange.start;
page.modalSymbolRate = new ModalMessage({
    visible: false,
    title: gettext('Symbol rate'),
    children: [
        new RadioList({
            cycle: true,
            size: 5,
            data: listData,
            scroll: modalScroll = new Scrollbar(),
            focusIndex: focusIndex,
            events: {
                'click:item': function () {
                    page.modalSymbolRate.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalSymbolRate.hide();
                        page.middlePanel.focus();
                    }
                },
                select: function ( item ) {
                    scanConfig.symbolRate = item.data.value;
                    middleList.links.symbolRate.links.$text.innerText = scanConfig.symbolRate;
                    symbolRateText.value = scanConfig.symbolRate + '';
                }
            }
        }),
        modalScroll
    ]
});
page.add(page.modalSymbolRate);


page.modalModulation = new ModalMessage({
    visible: false,
    title: gettext('Modulation'),
    children: [
        new RadioList({
            cycle: true,
            size: 5,
            focusIndex: 0,
            data: [
                {
                    state: true,
                    value: 0,
                    title: gettext('Auto')
                },
                {
                    value: 1,
                    title: '16 QAM'
                },
                {
                    value: 2,
                    title: '32 QAM'
                },
                {
                    value: 3,
                    title: '64 QAM'
                },
                {
                    value: 4,
                    title: '128 QAM'
                },
                {
                    value: 5,
                    title: '256 QAM'
                }
            ],
            events: {
                'click:item': function () {
                    page.modalModulation.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalModulation.hide();
                        page.middlePanel.focus();
                    }
                },
                select: function ( item ) {
                    scanConfig.modulation = item.data.value;
                    middleList.links.modulation.links.$text.innerText = item.data.title;
                    modulationText.value = item.data.title;
                }
            }
        })
    ]
});
page.add(page.modalModulation);


page.modalBand = new ModalMessage({
    visible: false,
    title: gettext('Modulation'),
    children: [
        new RadioList({
            cycle: true,
            size: 3,
            focusIndex: 2,
            data: [
                {
                    value: 6,
                    title: '6'
                },
                {
                    value: 7,
                    title: '7'
                },
                {
                    value: 8,
                    title: '8',
                    state: true
                }
            ],
            events: {
                'click:item': function () {
                    page.modalBand.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalBand.hide();
                        page.middlePanel.focus();
                    }
                },
                select: function ( item ) {
                    scanConfig.bandwidth = item.data.value;
                    middleList.links.bandwidth.links.$text.innerText = item.data.title;
                    bandwidthText.value = item.data.title;
                }
            }
        })
    ]
});
page.add(page.modalBand);


listData = [];
for ( index = frequencyRange.start; index <= frequencyRange.end; index += frequencyRange.step ) {
    listData.push({
        state: index === scanConfig.frequencyStart,
        value: index,
        title: index
    });
}
focusIndex = (scanConfig.frequencyStart - frequencyRange.start) / frequencyRange.step;

page.modalFrequencyStart = new ModalMessage({
    visible: false,
    title: gettext('Start frequency (KHz)'),
    children: [
        new RadioList({
            cycle: true,
            size: 5,
            data: listData,
            scroll: modalScroll = new Scrollbar(),
            focusIndex: focusIndex,
            events: {
                'click:item': function () {
                    page.footer.show();
                    page.modalFrequencyStart.hide();
                    page.middlePanel.focus();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalFrequencyStart.hide();
                        page.middlePanel.focus();
                        page.footer.show();
                    }
                },
                select: function ( item ) {
                    scanConfig.frequencyStart = item.data.value;
                    middleList.links.frequencyStart.links.$text.innerText = scanConfig.frequencyStart;
                    frequencyStartText.value = scanConfig.frequencyStart + '';
                }
            }
        }),
        modalScroll
    ]
});
page.add(page.modalFrequencyStart);


listData = [];
for ( index = frequencyRange.start; index <= frequencyRange.end; index += frequencyRange.step ) {
    listData.push(
        {
            state: index === scanConfig.frequencyEnd,
            value: index,
            title: index
        }
    );
}
focusIndex = (scanConfig.frequencyEnd - frequencyRange.start) / frequencyRange.step;

page.modalFrequencyEnd = new ModalMessage({
    visible: false,
    title: gettext('End frequency (KHz)'),
    children: [
        new RadioList({
            cycle: true,
            size: 5,
            data: listData,
            scroll: modalScroll = new Scrollbar(),
            focusIndex: focusIndex,
            events: {
                'click:item': function () {
                    page.modalFrequencyEnd.hide();
                    page.middlePanel.focus();
                    page.footer.show();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalFrequencyEnd.hide();
                        page.middlePanel.focus();
                        page.footer.show();
                    }
                },
                select: function ( item ) {
                    scanConfig.frequencyEnd = item.data.value;
                    middleList.links.frequencyEnd.links.$text.innerText = scanConfig.frequencyEnd;
                    frequencyEndText.value = scanConfig.frequencyEnd + '';
                }
            }
        }),
        modalScroll
    ]
});
page.add(page.modalFrequencyEnd);


listData = [];
for ( index = frequencyRange.start; index <= frequencyRange.end; index += frequencyRange.step ) {
    listData.push(
        {
            state: index === scanConfig.frequency,
            value: index,
            title: index
        }
    );
}
focusIndex = (scanConfig.frequency - frequencyRange.start) / frequencyRange.step;

page.modalFrequency = new ModalMessage({
    visible: false,
    title: gettext('Frequency (KHz)'),
    children: [
        new RadioList({
            cycle: true,
            size: 5,
            data: listData,
            scroll: modalScroll = new Scrollbar(),
            focusIndex: focusIndex,
            events: {
                'click:item': function () {
                    page.modalFrequency.hide();
                    page.middlePanel.focus();
                    page.footer.show();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back ) {
                        event.stop = true;
                        page.modalFrequency.hide();
                        page.middlePanel.focus();
                        page.footer.show();
                    }
                },
                select: function ( item ) {
                    scanConfig.frequency = item.data.value;
                    middleList.links.frequency.links.$text.innerText = scanConfig.frequency;
                    frequencyItemText.value = scanConfig.frequency + '';
                }
            }
        }),
        modalScroll
    ]
});
page.add(page.modalFrequency);


// middle panel (list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('Scan DVB channels'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});


page.middlePanel.scroll = new Scrollbar();

page.middlePanel.add(middleList = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 6,
    className: 'padded',
    scroll: page.middlePanel.scroll,
    events: {
        overflow: function () {
            middleList.$focusItem.classList.remove('focus');
            page.middlePanel.scroll.hide();
            page.middlePanel.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        },
        'focus:item': function ( data ) {
            if ( data.$curr.data.manualEdit ) {
                page.footer.show();
            } else {
                page.footer.hide();
            }
        }
    },
    data: []
}), page.middlePanel.scroll);


if ( DEVELOP ) {
    window.config = scanConfig;
    window.middleList = middleList;
    window.autoList = autoList;
}


page.middlePanel.add(page.middlePanel.button = new Button({
    value: gettext('Start'),
    className: 'bottom theme-footer',
    $node: page.middlePanel.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            app.route(app.pages.scanning, scanConfig);
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                middleList.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                middleList.$focusItem.classList.add('focus');
                middleList.focusIndex(middleList.data.length - 1);
            } else if ( event.code === keys.down ) {
                middleList.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                middleList.$focusItem.classList.add('focus');
                middleList.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.middlePanel.button.events['click'] ) {
                    page.middlePanel.button.emit('click', {event: event});
                }
            }
        }
    }
}));

// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetInfo'),
    focusIndex: 0,
    panels: [page.middlePanel]
});
page.add(page.panelSet);


page.middlePanel.reset = function () {
    var data = [],
        typeIndex,
        type = app.provider.types.current;

    scanConfig.more = app.provider.scanOptions.more;
    for ( typeIndex = 0; typeIndex < type.length; typeIndex++ ) {
        if ( type[typeIndex].type === scanConfig.currentType.type ) {
            scanConfig.currentType = type[typeIndex];
            break;
        }
    }
    if ( !scanConfig.currentType.type ) {
        scanConfig.currentType = type[0];
    }

    typeItemText.value = scanConfig.currentType.name;

    if ( scanConfig.manual ) {
        if ( scanConfig.more ) {
            data = manualMoreList;
        } else {
            data = manualList;
        }
    } else if ( scanConfig.more ) {
        data = autoList;
    } else {
        data = autoList.slice(0, 2);
    }

    $channelsCount.innerText = data.length;
    middleList.setData({data: data, focusIndex: 0});
};

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.main);
            event.stop = true;
            break;
    }
});


page.addListener('show', function () {
    page.middlePanel.reset();
    page.panelSet.show();
    page.panelSet.focus();
});


// public
module.exports = page;
